import client from "./client";

export interface FrameIOAccount {
  id: string;
  name: string;
}

/**
 * Get all Frame.io accounts from Frame.io API (admin only).
 */
export async function getFrameIOAccounts(): Promise<FrameIOAccount[]> {
  const response = await client.get<FrameIOAccount[]>("/users/frameio-accounts");
  return response.data;
}

/**
 * Get Frame.io accounts the authenticated user has access to.
 */
export async function getMyFrameIOAccounts(): Promise<FrameIOAccount[]> {
  const response = await client.get<FrameIOAccount[]>("/user/me/frameio-accounts");
  return response.data;
}
